// /admin — layout parent for the tab routes. A bare /admin lands on
// Overview; the tab itself is the URL (deep-linkable, back/forward-able,
// refresh-safe — the CRM-grade navigation the audit flagged).

import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin')({
  beforeLoad: ({ location }) => {
    if (location.pathname === '/admin' || location.pathname === '/admin/') {
      throw redirect({ to: '/admin/$tab', params: { tab: 'overview' } });
    }
  },
  component: Outlet,
});
